/**
 * Corporate-Events membership subscription (R26-815).
 * Advisor read-only endpoint. Response is camelCase; query params are snake_case.
 * The list includes CANCELLED history (ordered -created_at) and has no server
 * filters — pick the current row client-side.
 */
export default {
  name: 'eventSubscription',
  namespace: 'event_subscriptions',
  methods: [
    {
      name: 'filter',
      params: ['limit', 'offset', 'status', 'ordering'],
      successCode: 200,
      method: 'Get',
      url: ({ namespace }) => `/v1/${namespace}/`,
      urlParams: [],
      seq: false
    }
  ]
}
